export default __webpack_public_path__ + "img/man-laptop.c775bfbb.png";